export default "__VITE_ASSET__DPPDdRjC__"